import React from 'react';
import { Box } from '@mui/material';
import moment from 'moment';

import { Lead } from '@tassomutuo-backoffice/types';
import useLeadActionRequired, {
  ActionRequiredType,
} from '../hooks/useLeadActionRequired';
import LeadActionCounter from './LeadActionCounter';
import {
  getHsUpdateAlertDateInLocalStorage,
  getUserInLocalStorage,
} from '../../../services/localStorage/localStorage';

interface IProps {
  leadsUnderManagement: Lead[];
  onLeadActionCounterClick: (type: ActionRequiredType) => void;
}

const LeadsUnderManagementActionSummary = ({
  leadsUnderManagement,
  onLeadActionCounterClick,
}: IProps) => {
  const { getActionRequiredCounters } = useLeadActionRequired();

  const actionRequiredCounters =
    getActionRequiredCounters(leadsUnderManagement);

  if (
    actionRequiredCounters.appointmentToBeReschedule === 0 &&
    actionRequiredCounters.oldUpdateLeads === 0 &&
    actionRequiredCounters.appointmentHasPassed === 0 &&
    actionRequiredCounters.appointmentToBeConfirmed === 0
  )
    return null;

  // GESTIONE DEL BANNER ALERT
  const daysToAlert = 60; // <----- QUANDO INIZIARE A VEDERE L'ALERT
  let daysToMail = 21; // <---- GIORNI ALLA MAIL

  const firstAlertDate = getHsUpdateAlertDateInLocalStorage();
  console.log(firstAlertDate);
  if (firstAlertDate) {
    daysToMail -= moment().diff(moment(firstAlertDate), 'days');
  } else {
    const user = getUserInLocalStorage();
    if (user?.updateAlertDate) {
      daysToMail -= moment().diff(moment(user.updateAlertDate), 'days');
    }
  }

  const numberOfOldest = actionRequiredCounters.oldest;

  const updateDates = actionRequiredCounters.notes_last_updated;
  console.log(updateDates);
  const oldestUpdate = updateDates.reduce((oldest, current) => {
    if (
      typeof current !== 'undefined' &&
      typeof oldest !== 'undefined' &&
      oldest !== null &&
      oldest !== null
    )
      return new Date(current) < new Date(oldest) ? current : oldest;
    return new Date().toString();
  }, undefined);
  const timeSinceOldest = moment().diff(moment(oldestUpdate), 'days');
  console.log(timeSinceOldest);
  const userAlert = timeSinceOldest >= daysToAlert;

  let remainingDaysToMail = daysToMail;
  if (remainingDaysToMail < 0) {
    remainingDaysToMail = 0;
  }

  return (
    <>
      {userAlert && (
        <Box
          px={4}
          py={4}
          style={{
            display: 'flex',
            gap: '32px',
            flexWrap: 'wrap',
            paddingBottom: '0',
          }}
        >
          <Box
            px={4}
            py={4}
            style={{
              color: '#ffffff',
              background: '#ff3131',
              textAlign: 'center',
              flexGrow: '3',
              borderRadius: '20px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexDirection: 'column',
            }}
          >
            <h2
              style={{ fontWeight: 'bold', margin: '0' }}
            >{`Hai ${numberOfOldest} lead senza aggiornamento per più di ${daysToAlert} giorni`}</h2>
            <p
              style={{ margin: '0', fontSize: '20px', lineHeight: '26px' }}
            >{`Allo scadere dei giorni rimanenti per l'aggiornamento verrà inviata una mail ai soci Euroansa.`}</p>
            <div
              style={{
                textDecoration: 'underline',
                cursor: 'pointer',
                margin: '0',
                fontSize: '18px',
                lineHeight: '25px',
              }}
              onClick={() => onLeadActionCounterClick('oldUpdate')}
            >
              {`Clicca qui per accedere alla sezione con le lead da aggiornare!`}
            </div>
          </Box>
          <Box
            px={4}
            py={4}
            style={{
              color: '#ff3131',
              background: '#ffffff',
              textAlign: 'center',
              flex: '4 1 0%',
              border: '2px solid #ff3131',
              borderRadius: '20px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexDirection: 'column',
            }}
          >
            <h2
              style={{ margin: '0', lineHeight: '25px' }}
            >{`Giorni rimanenti per l'aggiornamento`}</h2>
            <div style={{ fontSize: '36px', fontWeight: 'bold' }}>
              {remainingDaysToMail}
            </div>
          </Box>
        </Box>
      )}
      <Box px={4} py={4} className="no-print">
        <Box display="flex" gap={4} flexWrap="wrap" mt={2}>
          {actionRequiredCounters.appointmentToBeReschedule > 0 && (
            <LeadActionCounter
              title="Appuntamenti da rifissare"
              count={actionRequiredCounters.appointmentToBeReschedule}
              onClick={() =>
                onLeadActionCounterClick('appointmentToBeRescheduled')
              }
            />
          )}
          {actionRequiredCounters.oldUpdateLeads > 0 && (
            <LeadActionCounter
              title="Lead non aggiornate"
              count={actionRequiredCounters.oldUpdateLeads}
              onClick={() => onLeadActionCounterClick('oldUpdate')}
            />
          )}
          {actionRequiredCounters.appointmentHasPassed > 0 && (
            <LeadActionCounter
              title="Lead da aggiornare (appuntamento passato)"
              count={actionRequiredCounters.appointmentHasPassed}
              onClick={() => onLeadActionCounterClick('appointmentHasPassed')}
            />
          )}

          {actionRequiredCounters.appointmentToBeConfirmed > 0 && (
            <LeadActionCounter
              title="Appuntamenti da confermare"
              count={actionRequiredCounters.appointmentToBeConfirmed}
              onClick={() =>
                onLeadActionCounterClick('appointmentToBeConfirmed')
              }
            />
          )}
        </Box>
      </Box>
    </>
  );
};

export default LeadsUnderManagementActionSummary;
